import { request } from '@/shared/api/request'
export const refreshConsent = (externalId) => {
	return request({
		url: `/proactive/refreshConsent/${externalId}`,
		method: 'POST',
	})
}